// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ql-mention-list {
    list-style: none;
    list-style-type: none;
    list-style-position: inside;
    padding: 0;
    margin: 0;
}
.ql-mention-list-item {
    padding: 6px;
}
.ql-mention-list-item.selected {
    background-color: #002c932e;
    border: 0px solid white;
    border-radius: 2px;
    font-size: 110%;
}
.ql-mention-list-container {
    border: 2px solid gray;
    background-color: white;
    box-shadow: 0 5px 5px 0 gray, 0 5px 5px 0 gray;
}
.search-match {
    background-color: #f7f7f7b5;
}
.p-transparent-button.p-button:focus {
    box-shadow: 0 0 white;
}
`, "",{"version":3,"sources":["webpack://./lino_react/react/components/TextFieldElement.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,2BAA2B;IAC3B,UAAU;IACV,SAAS;AACb;AACA;IACI,YAAY;AAChB;AACA;IACI,2BAA2B;IAC3B,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,8CAA8C;AAClD;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,qBAAqB;AACzB","sourcesContent":[".ql-mention-list {\n    list-style: none;\n    list-style-type: none;\n    list-style-position: inside;\n    padding: 0;\n    margin: 0;\n}\n.ql-mention-list-item {\n    padding: 6px;\n}\n.ql-mention-list-item.selected {\n    background-color: #002c932e;\n    border: 0px solid white;\n    border-radius: 2px;\n    font-size: 110%;\n}\n.ql-mention-list-container {\n    border: 2px solid gray;\n    background-color: white;\n    box-shadow: 0 5px 5px 0 gray, 0 5px 5px 0 gray;\n}\n.search-match {\n    background-color: #f7f7f7b5;\n}\n.p-transparent-button.p-button:focus {\n    box-shadow: 0 0 white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
